import { ReadProject } from "@/types/project";

export const generateDisplayName = (
  project?: Pick<ReadProject, "name" | "client">,
) => {
  if (project === undefined) {
    return "";
  }
  return `${project.name} (${project.client})`;
};
